import { ToastConsumerContext, useToasts } from 'react-toast-notifications';

import axios, { AxiosError } from 'axios';

export function toastHookToContext(tm: ReturnType<typeof useToasts>): ToastConsumerContext {
  return {
    add: tm.addToast,
    remove: tm.removeToast,
    toasts: tm.toastStack,
  };
}

export function apiErrorHandler<T extends MessageResponse = MessageResponse>(
  toastManager: ToastConsumerContext,
  error: Error | AxiosError<T>,
  finallyFn?: () => void
) {
  const e = error as AxiosError<T>;

  if (axios.isCancel(e)) {
    // request cancelled
    return;
  }

  if (e.response?.status === 401 || e.response?.status === 403) {
    // logged out
    return;
  }

  console.error(e);

  let message = '';

  if (e.response?.data) {
    message = e.response.data.message;
  } else if (e.request?.response) {
    const data = JSON.parse(e.request.response);
    message = data.message || error.message;
  } else if (error.message) {
    message = error.message;
  }

  if (message) {
    toastManager.add(message);
  }

  if (finallyFn) {
    finallyFn();
  }
}
